import { Entity } from "@models/Entity";
import { messageFor } from "@lib/errors";
import type { MutationAction } from "@lib/errors";

/**
 * Legacy adapter — prefer setting `meta: { entity, action }` on a TanStack
 * Query mutation so the global handler toasts automatically.
 */
export const returnErrorMessage = (
  entity: Entity,
  error: unknown,
  action: MutationAction = "save"
) => messageFor(entity, action, error);
